module.exports = __webpack_public_path__ + "static/media/third_home.eea6fad1.png";